import { render, staticRenderFns } from "./TZCN19508.vue?vue&type=template&id=5213530d&scoped=true&"
import script from "./TZCN19508.vue?vue&type=script&lang=js&"
export * from "./TZCN19508.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213530d",
  null
  
)

export default component.exports